import React, { FC } from 'react';
import { IconButton, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';

interface Props {
  query: string;
  onClear: () => void;
}

const useStyles = makeStyles(() => ({
  deleteIcon: {
    transform: 'rotate(45deg)',
  },
  transparent: {
    color: 'transparent',
  },
}));

const EndAdornment: FC<Props> = ({ query, onClear }) => {
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      <IconButton onClick={onClear}>
        <AddCircleIcon className={query ? classes.deleteIcon : classes.transparent} />
      </IconButton>
    </InputAdornment>
  );
};

export default EndAdornment;
